import { SignUp } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';

/**
 * Sign Up page using Clerk's pre-built SignUp component.
 * Automatically handles registration with email verification.
 */
export function SignUpPage() {
  return (
    <div className="auth-page">
      <SignUp
        path="/sign-up"
        routing="path"
        signInUrl="/sign-in"
        afterSignUpUrl="/app"
        appearance={{
          baseTheme: dark,
          variables: {
            colorPrimary: '#7c5cff',
            colorBackground: '#111a33',
            colorInputBackground: '#0f1730',
            colorInputText: '#eaf0ff',
            colorText: '#eaf0ff',
            colorTextSecondary: '#9fb0d0',
            colorDanger: '#fb7185',
            borderRadius: '12px',
          },
          elements: {
            card: {
              backgroundColor: '#111a33',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              boxShadow: '0 12px 30px rgba(0, 0, 0, 0.35)',
            },
            headerTitle: {
              color: '#eaf0ff',
            },
            headerSubtitle: {
              color: '#9fb0d0',
            },
            formFieldLabel: {
              color: '#9fb0d0',
            },
            formFieldInput: {
              backgroundColor: '#0f1730',
              borderColor: 'rgba(255, 255, 255, 0.08)',
              color: '#eaf0ff',
            },
            formButtonPrimary: {
              backgroundColor: '#7c5cff',
              color: '#fff',
            },
            footerActionLink: {
              color: '#7c5cff',
            },
            identityPreviewEditButton: {
              color: '#7c5cff',
            },
            formFieldAction: {
              color: '#7c5cff',
            },
            otpCodeFieldInput: {
              backgroundColor: '#0f1730',
              borderColor: 'rgba(255, 255, 255, 0.08)',
              color: '#eaf0ff',
            },
            dividerLine: {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
            dividerText: {
              color: '#9fb0d0',
            },
            socialButtonsBlockButton: {
              backgroundColor: '#0f1730',
              borderColor: 'rgba(255, 255, 255, 0.08)',
              color: '#eaf0ff',
            },
            socialButtonsBlockButtonText: {
              color: '#eaf0ff',
            },
            formFieldInputShowPasswordButton: {
              color: '#9fb0d0',
            },
            alertText: {
              color: '#eaf0ff',
            },
            formFieldSuccessText: {
              color: '#4ade80',
            },
          },
        }}
      />
    </div>
  );
}
